import coreApi from '../../../shared/api/coreApi';

export interface OnboardingStep {
  aboveHeadline: string;
  headline: string;
  description: string;
  image: string;
  lottie?: string;
}

interface OnboardingResponse {
  success: boolean;
  data: OnboardingStep[];
}

export const onboardingService = {
  async getOnboardingSteps(): Promise<OnboardingStep[]> {
    try {
      const response = await coreApi.get<OnboardingResponse>('/utility/onboarding');
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch onboarding steps:', error);
      throw error;
    }
  }
}; 